import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";
import { SignUpButton } from "scmp-app/components/newsletter/sign-up-button";

export const StyledSignUpButton = styled(SignUpButton)`
  max-inline-size: 140px;
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: auto;

  background-color: #e2e2e2;
  aspect-ratio: 3/2;

  svg {
    inline-size: 80px;
    block-size: 64px;
    margin: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  align-self: stretch;

  inline-size: 100%;
  block-size: 100%;
  max-inline-size: 300px;
  padding: 12px;

  border: 1px solid #cccccc;

  background: #ffffff;

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Summary = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;

  color: #000000;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Name = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 130%;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Description = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%; /* 18.2px */
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const NumberOfSignedUpUsers = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;

  color: #666666;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 100%;

  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  margin-block-start: auto;
`;

export const Preview = styled(EntityLink)`
  padding: 8px;

  color: #333333;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;

  font-feature-settings:
    "liga" off,
    "clig" off;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const ImageContainer = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: auto;
  aspect-ratio: 3/2;
`;

export const StyledBaseImage = styled(BaseImage)``;

export const Flag = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;

  padding-block: 2px;
  padding-inline: 4px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;

  background-color: #000000;

  font-feature-settings:
    "liga" off,
    "clig" off;
`;
